/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_Q6Inputs */

const en_to_yaml_faq_q6 = /** @type {(inputs: To_Yaml_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are some strings quoted and others not?`)
};

const ko_to_yaml_faq_q6 = /** @type {(inputs: To_Yaml_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`왜 어떤 문자열은 인용되고 어떤 것은 인용되지 않나요?`)
};

const ja_to_yaml_faq_q6 = /** @type {(inputs: To_Yaml_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ一部の文字列は引用され、ほかは引用されないのですか`)
};

/**
* | output |
* | --- |
* | "Why are some strings quoted and others not?" |
*
* @param {To_Yaml_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_q6 = /** @type {((inputs?: To_Yaml_Faq_Q6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_Q6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_q6(inputs)
	if (locale === "ko") return ko_to_yaml_faq_q6(inputs)
	return ja_to_yaml_faq_q6(inputs)
});